module.exports = __webpack_public_path__ + "static/WTE-logo-368665254c6c8bb7b286aec6717b33f0.webp";